import React, { useState, useEffect } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ProjectCard from "../../components/Projects/ProjectCard";
import api from "../../services/api";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";

const UnitsProjectsPage = () => {
  const [projects, setProjects] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const storedUser = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    fetchProjects(storedUser.type);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchProjects = async (type) => {
    try {
      const endpoint =
        type === "admin"
          ? "/projects/unpaginated"
          : "/projects/developer/projects";
      const { data } = await api.get(endpoint);
      if (data.status) {
        setProjects(data.response.data);
      } else {
        console.error("Error fetching projects:", data.message);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  const filteredProjects = projects.filter((project) =>
    project.name?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <MasterLayout>
      <Breadcrumb title="Projects" />
      <p>Choose a project to access its units.</p>
      {/* Search Input */}

      {/* Search and Add Unit Button */}
      <div className="d-flex justify-content-between mb-3"> {/* Changed to space-between */}
        <div className="w-25"> {/* Moved search input inside a div */}
          <input
            type="text"
            placeholder="Search by project name..."
            className="form-control"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
        <div> {/* Added a div for the button */}
          <Link
            to="/add-unit"
            className="btn btn-primary btn-sm d-flex align-items-center gap-2"
          >
            <Icon icon="ic:baseline-plus" className="icon text-sm" />
            Add New Unit
          </Link>
        </div>
      </div>

      <div className="row gy-4">
        {filteredProjects.length > 0 ? (
          filteredProjects.map((project) => (
            <div key={project.id} className="col-xxl-3 col-sm-6">
              <ProjectCard project={project} />
            </div>
          ))
        ) : (
          <div className="col-12 text-center">
            <p>No projects found.</p>
          </div>
        )}
      </div>
    </MasterLayout>
  );
};

export default UnitsProjectsPage;